// @ts-strict-ignore
export default function datalayerPush(data) {
  const isProd = process.env.NODE_ENV === 'production'

  if (typeof window !== 'undefined' && window.dataLayer) {
    // eslint-disable-next-line no-console
    isProd ? window.dataLayer.push(data) : console.log(data)
  }
}
